import request from "@/utils/request"

export default function agentCreatOrder(params) {
    return request({
        url: `/fund/order/agentCreatOrder`,
        params,
        method: 'post',
    })
}
